import videojs from 'video.js';

/** 
 * This function runs before the player is initialized.  We can include any modifications to video.js class prototypes here.
 * Add to it as needed in order to pick up changes to video.js that we need to port to our current version.
 * In the event that we finally update to a more current version, remove anything that is built into that version.
**/
export function applyCherryPickedVideoJSFixes() {
    // Begin fixes for chapters (picked from version 7.19.0, 3/21/22).  Necessary for the proper functioning of intro and outro.
    let ChaptersButton = videojs.getComponent('ChaptersButton');
    let ChaptersTrackMenuItem = videojs.getComponent('ChaptersTrackMenuItem');
    let MenuItem = videojs.getComponent('MenuItem');
    let TextTrackButton = videojs.getComponent('TextTrackButton');
    let VolumeBar = videojs.getComponent('VolumeBar');
    let Button = videojs.getComponent('Button');

    ChaptersButton.prototype.selectCurrentChild_ = function selectCurrentChild() {
        this.items.forEach(item => {
            item.selected(this.track_.activeCues[0] === item.cue);
        });
    };

    ChaptersButton.prototype.update = function update(event) {
        if (event && event.track && event.track.kind !== 'chapters') {
            return;
        }

        const track = this.findChaptersTrack();

        if (track !== this.track_) {
            // Set new track
            this.setTrack(track);
            TextTrackButton.prototype.update.call(this);
        } else if (!this.items || (track && track.cues && track.cues.length !== this.items.length)) {
            // Update the menu initially and if the number of cues has changed
            TextTrackButton.prototype.update.call(this);
        }
    };

    ChaptersButton.prototype.setTrack = function setTrack(track) {
        if (this.track_ === track) {
            return;
        }

        if (!this.updateHandler_) {
            this.updateHandler_ = this.update.bind(this);
        }

        // here this.track_ refers to the old track instance
        if (this.track_) {
            const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
            if (remoteTextTrackEl) {
                remoteTextTrackEl.removeEventListener('load', this.updateHandler_);
            }

            this.track_.removeEventListener('cuechange', this.selectCurrentChild_.bind(this));

            this.track_ = null;
        }

        this.track_ = track;
        // here this.track_ refers to the new track instance
        if (this.track_) {
            this.track_.mode = 'hidden';
            const remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
            if (remoteTextTrackEl) {
                remoteTextTrackEl.addEventListener('load', this.updateHandler_);
            }

            this.track_.addEventListener('cuechange', this.selectCurrentChild_.bind(this));
        }
    };

    ChaptersTrackMenuItem.prototype.update = function update(event) {
        if (this.player_ == null) {
            return;
        }
        var cue = this.cue;
        var currentTime = this.player_.currentTime(); // vjs.log(currentTime, cue.startTime);

        this.selected(cue.startTime <= currentTime && currentTime < cue.endTime);
    };

    ChaptersTrackMenuItem.prototype.constructor = function (player, options) {
        const track = options.track;
        const cue = options.cue;
        const currentTime = player.currentTime();
        // Modify options for parent MenuItem class's init.
        options.selectable = true;
        options.multiSelectable = false;
        options.label = cue.text;
        options.selected = (cue.startTime <= currentTime && currentTime < cue.endTime);
        const menuItemConstructor = MenuItem.prototype.constructor.bind(this);
        menuItemConstructor(this, player, options);

        this.track = track;
        this.cue = cue;
    };

    ChaptersTrackMenuItem.prototype.handleClick = function handleClick(event) {
        MenuItem.prototype.handleClick.call(this);
        this.player_.currentTime(this.cue.startTime);
    };

    // End fixes for chapters from v7.19.0

    // Begin accessibility fixes

    VolumeBar.prototype.updateARIAAttributes = function updateARIAAttributes(event) {
        var ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
        const label = this.localize('Volume Level');
        this.el_.setAttribute('aria-valuenow', ariaValue);
        this.el_.setAttribute('aria-valuetext', label + ' ' + ariaValue + '%');
    };

    // Log a button click to the screen reader log
    Button.prototype.announceButtonClick = function announceButtonClick(localizeText) {
        if (this.activeText) {
            this.player_.controlsLog().logAction(this.activeText, localizeText);
        }
    };

    // End accessibility fixes
}